import { EOrderBookType, } from "@adapters/features/OrderBook/Presenters/action-interface/OrderBook";
import EQOrderBookActions from "@redux/feature/OrderBook/actions/eqOrderBook";
import COOrderBookActions from "@redux/feature/OrderBook/actions/coOrderBook";
import MFOrderBookActions from "@redux/feature/OrderBook/actions/mfOrderBook";
import EQSipOrderBookActions from "@redux/feature/OrderBook/actions/eqSipOrderBook";
import MFSipOrderBookActions from "@redux/feature/OrderBook/actions/mfSipOrderBook";
import MFOrderBookHoldingsActions from "@redux/feature/OrderBook/actions/mfOrderBookHoldings";
import NFOOrderBookActions from "@redux/feature/OrderBook/actions/nfoOrderBook";
import IPOOrderBookActions from "@redux/feature/OrderBook/actions/ipoOrderBook";
import NcdIPOOrderBookActions from "@redux/feature/OrderBook/actions/ncdIpoOrderbook";
export default (function () {
    var _a;
    return _a = {},
        _a[EOrderBookType.CO] = new COOrderBookActions(),
        _a[EOrderBookType.EQ] = new EQOrderBookActions(),
        _a[EOrderBookType.MF] = new MFOrderBookActions(),
        _a[EOrderBookType.NFO] = new NFOOrderBookActions(),
        _a[EOrderBookType.MFH] = new MFOrderBookHoldingsActions(),
        _a[EOrderBookType.EQSIP] = new EQSipOrderBookActions(),
        _a[EOrderBookType.MFSIP] = new MFSipOrderBookActions(),
        _a[EOrderBookType.IPO] = new IPOOrderBookActions(),
        _a[EOrderBookType.NCDIPO] = new NcdIPOOrderBookActions(),
        _a;
});
